// removed by extract-text-webpack-plugin
module.exports = {"root":"textarea--root--LDAm4eww input--root--3bmcFHMd","disabled":"textarea--disabled--1DVBn0QX input--disabled--2nurGDq5"};


//////////////////
// WEBPACK FOOTER
// ./components/forms/textarea/styles.css
// module id = ./components/forms/textarea/styles.css
// module chunks = 0